/**
 * Lightweight frontend logger.
 *
 * In development: logs to console with tag prefix.
 * In production: suppresses debug/warn, keeps errors (can be
 * extended to send errors to a remote service like Sentry).
 */
const isDev = import.meta.env.DEV

function formatTag(tag: string): string {
  return `[${tag}]`
}

export const logger = {
  /** Verbose debug info — development only */
  debug(tag: string, message: string, ...data: unknown[]): void {
    if (isDev) {
      console.debug(formatTag(tag), message, ...data)
    }
  },

  /** Operational info — development only */
  info(tag: string, message: string, ...data: unknown[]): void {
    if (isDev) {
      console.info(formatTag(tag), message, ...data)
    }
  },

  /** Non-critical warnings — development only */
  warn(tag: string, message: string, ...data: unknown[]): void {
    if (isDev) {
      console.warn(formatTag(tag), message, ...data)
    }
  },

  /** Errors — always logged (extend for remote reporting) */
  error(tag: string, message: string, ...data: unknown[]): void {
    console.error(formatTag(tag), message, ...data)
  },
}
